import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "@/lib/api";
import { Wordmark } from "@/components/Brand";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/common";
import { Download, AudioLines, ArrowRight } from "lucide-react";

export default function PublicClip() {
  const { token } = useParams();
  const [clip, setClip] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    axios.get(`${API_BASE}/public/clips/${token}`)
      .then((r) => { setClip(r.data); setStatus("ok"); })
      .catch(() => setStatus("notfound"));
  }, [token]);

  return (
    <div className="fc-hero-bg fc-paper-noise flex min-h-screen flex-col items-center justify-center px-4 py-10">
      <div className="mb-6"><Wordmark withTagline /></div>
      <Card className="w-full max-w-lg border-border bg-card shadow-[0_18px_50px_rgba(20,20,20,0.10)]">
        <CardContent className="p-7">
          {status === "loading" && <div className="flex justify-center py-10"><Spinner /></div>}
          {status === "notfound" && (
            <div className="py-8 text-center">
              <AudioLines className="mx-auto h-10 w-10 text-muted-foreground" />
              <p className="mt-3 font-serif text-lg text-foreground">This clip isn't available</p>
              <p className="mt-1 text-sm text-muted-foreground">It may have been unshared or removed.</p>
              <Button asChild className="mt-4"><Link to="/">Visit Friday Conversations <ArrowRight className="ml-1 h-4 w-4" /></Link></Button>
            </div>
          )}
          {status === "ok" && clip && (
            <div>
              <p className="text-xs font-semibold uppercase tracking-wider text-primary">Friday Conversations · Clip</p>
              <h1 className="mt-1 font-serif text-2xl font-semibold text-foreground">{clip.title}</h1>
              {clip.speaker_label && <p className="mt-1 text-sm text-muted-foreground">Featuring {clip.speaker_label}</p>}
              <audio controls autoPlay className="mt-5 w-full" src={`${API_BASE}/public/clips/${token}/audio`} data-testid="public-clip-audio" />
              <div className="mt-4 flex items-center gap-2">
                <Button asChild variant="secondary"><a href={`${API_BASE}/public/clips/${token}/audio`} download><Download className="mr-1.5 h-4 w-4" />Download</a></Button>
                <Button asChild className="bg-primary text-primary-foreground hover:bg-[hsl(var(--primary-hover))]"><Link to="/register">Join the group <ArrowRight className="ml-1 h-4 w-4" /></Link></Button>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
